export const contactsData = {
    email: 'Elijahbusick.work@gmail.com',
    cell: '(828)-578-2114',
    Location: 'Charlotte, North Carolina'
}